/* tslint:disable */
/* eslint-disable */
/**
 * 
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { Episode } from './Episode';
import {
    EpisodeFromJSON,
    EpisodeFromJSONTyped,
    EpisodeToJSON,
} from './Episode';

/**
 * 
 * @export
 * @interface PaginatedEpisodeList
 */
export interface PaginatedEpisodeList {
    /**
     * 
     * @type {number}
     * @memberof PaginatedEpisodeList
     */
    count?: number;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEpisodeList
     */
    next?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PaginatedEpisodeList
     */
    previous?: string | null;
    /**
     * 
     * @type {Array<Episode>}
     * @memberof PaginatedEpisodeList
     */
    results?: Array<Episode>;
}

/**
 * Check if a given object implements the PaginatedEpisodeList interface.
 */
export function instanceOfPaginatedEpisodeList(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PaginatedEpisodeListFromJSON(json: any): PaginatedEpisodeList {
    return PaginatedEpisodeListFromJSONTyped(json, false);
}

export function PaginatedEpisodeListFromJSONTyped(json: any, ignoreDiscriminator: boolean): PaginatedEpisodeList {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'count': !exists(json, 'count') ? undefined : json['count'],
        'next': !exists(json, 'next') ? undefined : json['next'],
        'previous': !exists(json, 'previous') ? undefined : json['previous'],
        'results': !exists(json, 'results') ? undefined : ((json['results'] as Array<any>).map(EpisodeFromJSON)),
    };
}

export function PaginatedEpisodeListToJSON(value?: PaginatedEpisodeList | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'count': value.count,
        'next': value.next,
        'previous': value.previous,
        'results': value.results === undefined ? undefined : ((value.results as Array<any>).map(EpisodeToJSON)),
    };
}

